const webDataSourcesColors = [
  '#01a2e0',
  '#7fd1ee',
  '#cff2ff',
  '#ffffff'
];

export const pptxDataSourcesColors =
  webDataSourcesColors.map(color => color.replace('#ffffff', '#2d2d2d'));
export default webDataSourcesColors;



// WEBPACK FOOTER //
// ./src/constants/dataSourcesColors.js